import { render } from "./Kawalan.vue?vue&type=template&id=6da2d042"
import script from "./Kawalan.vue?vue&type=script&lang=js"
export * from "./Kawalan.vue?vue&type=script&lang=js"

import "./Kawalan.vue?vue&type=style&index=0&id=6da2d042&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__